export default __webpack_public_path__ + "static/media/aiSports.27bb8ce7.png";